mutation DeleteEvent($eventId: ID!) {
  result: StreamToolsDeleteEvent(eventId: $eventId) {
    id
    deleted
  }
}
